<section class="image-viewer" [class.image-viewer--fullscreen]="fullscreen()">
  <div class="image-viewer__toolbar">
    <button mat-icon-button type="button" (click)="zoomOut()" aria-label="縮小"><mat-icon>zoom_out</mat-icon></button>
    <span>{{ (zoom() * 100).toFixed(0) }}%</span>
    <button mat-icon-button type="button" (click)="zoomIn()" aria-label="放大"><mat-icon>zoom_in</mat-icon></button>
    <button mat-icon-button type="button" (click)="rotate()" aria-label="旋轉"><mat-icon>rotate_right</mat-icon></button>
    <button mat-button type="button" (click)="fit()">符合視窗</button>
    <span class="image-viewer__spacer"></span>
    <button mat-icon-button type="button" (click)="toggleFullscreen()" aria-label="切換全螢幕">
      <mat-icon>{{ fullscreen() ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
    </button>
  </div>
  <div class="image-viewer__stage">
    <img [src]="src()" [alt]="alt()" [style.transform]="'scale(' + zoom() + ') rotate(' + rotation() + 'deg)'" />
  </div>
</section>
